// extracted by mini-css-extract-plugin
export default {"btn":"AnswerBtn_btn__-3hNb","right":"AnswerBtn_right__RJrKh","wrong":"AnswerBtn_wrong__QyLpZ","disabled":"AnswerBtn_disabled__phXsa"};